<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">{{ room.name || 'Sala' }}</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Salas &amp; Interações <span class="sep">/</span> Operação da sala</div>
        </div>
        <router-link to="/app/rooms" class="appui-btn appui-btn--ghost" style="text-decoration:none"><i class="mdi mdi-arrow-left mr-1"></i> Voltar</router-link>
      </div>

      <div class="appui-room-grid">
        <!-- Controles de interatividade (salva ao alternar) -->
        <section class="appui-card" style="padding:18px 18px 20px">
          <h2 class="appui-sec-title">Controles de interatividade</h2>
          <p class="appui-sec-sub" style="margin-bottom:14px">Libere cada recurso nesta sala.</p>
          <div style="display:flex;flex-direction:column;gap:2px">
            <div v-for="t in toggles" :key="t.key" style="display:flex;justify-content:space-between;align-items:center;padding:8px 2px">
              <span style="font-size:12.5px;color:#495057">{{ t.label }}</span>
              <button class="appui-switch" :class="{ 'is-on': settings[t.key] }" @click="toggleSetting(t.key)"><span class="knob"></span></button>
            </div>
          </div>
        </section>

        <!-- Conteúdo por aba -->
        <div>
          <div class="appui-tabs">
            <button v-for="t in tabs" :key="t.key" :class="{ 'is-active': activeTab === t.key }" @click="activeTab = t.key">{{ t.label }}</button>
          </div>

          <!-- PERGUNTAS PRIVADAS -->
          <section v-if="activeTab === 'perguntas'" class="appui-card appui-card--flush">
            <div class="appui-tab-head">
              <span class="appui-sec-title">Perguntas privadas <small style="font-weight:400;color:#74788d">— respondidas individualmente</small></span>
              <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="loadAskings()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
            </div>
            <table class="appui-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Pergunta</th>
                  <th style="width:170px">Status</th>
                  <th style="width:160px;text-align:right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="a in askings" :key="a.id">
                  <td class="appui-link" @click="openReply(a, false)">{{ a.author ? a.author.name : '—' }}</td>
                  <td class="appui-link" style="color:#74788d" @click="openReply(a, false)">{{ a.author ? a.author.email : '—' }}</td>
                  <td class="appui-link" style="color:#74788d" :title="a.asking" @click="openReply(a, false)">{{ truncate(a.asking, 60) }}</td>
                  <td>
                    <b-dropdown v-if="!a.status" size="sm" variant="link" toggle-class="appui-status-drop">
                      <template v-slot:button-content>
                        <span class="appui-badge appui-badge--red">{{ statusLabels[0] }} <i class="mdi mdi-chevron-down"></i></span>
                      </template>
                      <b-dropdown-item @click="setAskingStatus(a, false, 1)">Respondida</b-dropdown-item>
                      <b-dropdown-item @click="setAskingStatus(a, false, 2)">Respondida ao vivo</b-dropdown-item>
                    </b-dropdown>
                    <span v-else class="appui-badge" :class="a.status === 1 ? 'appui-badge--green' : 'appui-badge--blue'">{{ statusLabels[a.status] }}</span>
                  </td>
                  <td style="text-align:right;white-space:nowrap">
                    <button class="appui-tbtn appui-tbtn--primary" style="margin-right:6px" @click="openReply(a, false)">Responder</button>
                    <button class="appui-tbtn appui-tbtn--danger" @click="delAsking(a, false)">Excluir</button>
                  </td>
                </tr>
                <tr v-if="!askings.length"><td colspan="5" class="appui-empty">Ainda não recebemos perguntas.</td></tr>
              </tbody>
            </table>
          </section>

          <!-- PERGUNTAS PÚBLICAS -->
          <section v-if="activeTab === 'publicas'" class="appui-card appui-card--flush">
            <div class="appui-tab-head">
              <span class="appui-sec-title">Perguntas públicas <small style="font-weight:400;color:#74788d">— ranqueadas por votos</small></span>
              <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="loadPublicAskings()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
            </div>
            <table class="appui-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Pergunta</th>
                  <th style="width:70px">Votos</th>
                  <th style="width:170px">Status</th>
                  <th style="width:160px;text-align:right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="a in publicAskings" :key="a.id">
                  <td class="appui-link" @click="openReply(a, true)">{{ a.author ? a.author.name : '—' }}</td>
                  <td class="appui-link" style="color:#74788d" @click="openReply(a, true)">{{ a.author ? a.author.email : '—' }}</td>
                  <td class="appui-link" style="color:#74788d" :title="a.asking" @click="openReply(a, true)">{{ truncate(a.asking, 50) }}</td>
                  <td><span style="font-weight:700;color:#495057">{{ votesOf(a) }}</span></td>
                  <td>
                    <b-dropdown v-if="!a.status" size="sm" variant="link" toggle-class="appui-status-drop">
                      <template v-slot:button-content>
                        <span class="appui-badge appui-badge--red">{{ statusLabels[0] }} <i class="mdi mdi-chevron-down"></i></span>
                      </template>
                      <b-dropdown-item @click="setAskingStatus(a, true, 1)">Respondida</b-dropdown-item>
                      <b-dropdown-item @click="setAskingStatus(a, true, 2)">Respondida ao vivo</b-dropdown-item>
                    </b-dropdown>
                    <span v-else class="appui-badge" :class="a.status === 1 ? 'appui-badge--green' : 'appui-badge--blue'">{{ statusLabels[a.status] }}</span>
                  </td>
                  <td style="text-align:right;white-space:nowrap">
                    <button class="appui-tbtn appui-tbtn--primary" style="margin-right:6px" @click="openReply(a, true)">Responder</button>
                    <button class="appui-tbtn appui-tbtn--danger" @click="delAsking(a, true)">Excluir</button>
                  </td>
                </tr>
                <tr v-if="!publicAskings.length"><td colspan="6" class="appui-empty">Ainda não recebemos perguntas.</td></tr>
              </tbody>
            </table>
          </section>

          <!-- ENQUETES -->
          <section v-if="activeTab === 'enquete'" class="appui-card appui-card--flush">
            <div class="appui-tab-head">
              <span class="appui-sec-title">Enquetes</span>
              <button class="appui-btn appui-btn--primary appui-btn--sm" @click="openPoll()">+ Inserir enquete</button>
            </div>
            <table class="appui-table">
              <thead>
                <tr>
                  <th style="width:46px"></th>
                  <th style="width:56px">Seq</th>
                  <th>Enquete</th>
                  <th style="width:80px">Opções</th>
                  <th style="width:90px">Liberada</th>
                  <th style="width:70px;text-align:right">Ações</th>
                </tr>
              </thead>
              <draggable
                v-model="polls"
                :element="'tbody'"
                :options="{ animation: 180, handle: '.appui-grip', ghostClass: 'appui-drag-ghost' }"
                @end="reorderPolls"
              >
                <tr v-for="p in polls" :key="p.id" :class="{ 'appui-row-archived': p.archived }">
                  <td><span class="appui-grip" title="Arraste para reordenar">⠿</span></td>
                  <td><span class="appui-badge appui-badge--blue">{{ p.sequence }}</span></td>
                  <td :title="p.description" style="color:#495057">{{ truncate(p.description, 70) }}<span v-if="p.archived" class="appui-badge appui-badge--muted" style="margin-left:8px">Arquivada</span></td>
                  <td style="color:#74788d">{{ (p.options || []).length }}</td>
                  <td>
                    <button class="appui-switch" :class="{ 'is-on': p.status }" :disabled="!!p.archived" @click="toggleLive(p, 'poll')"><span class="knob"></span></button>
                  </td>
                  <td style="text-align:right">
                    <b-dropdown right variant="white" toggle-class="p-0 appui-dots">
                      <template v-slot:button-content><i class="mdi mdi-dots-horizontal font-size-18"></i></template>
                      <b-dropdown-item @click="openPoll(p)"><i class="fas fa-pencil-alt text-success mr-1"></i> Editar</b-dropdown-item>
                      <b-dropdown-item @click="archiveItem(p, 'poll')"><i class="fas fa-archive text-warning mr-1"></i> {{ p.archived ? 'Desarquivar' : 'Arquivar' }}</b-dropdown-item>
                      <b-dropdown-item @click="delPoll(p)"><i class="fas fa-trash-alt text-danger mr-1"></i> Excluir</b-dropdown-item>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item @click="openChart(p, 'poll')"><i class="fas fa-chart-bar text-primary mr-1"></i> Gráfico</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                <tr v-if="!polls.length"><td colspan="6" class="appui-empty">Nenhuma enquete configurada.</td></tr>
              </draggable>
            </table>
          </section>

          <!-- QUIZ -->
          <section v-if="activeTab === 'quiz'" class="appui-card appui-card--flush">
            <div class="appui-tab-head">
              <span class="appui-sec-title">Quiz</span>
              <button class="appui-btn appui-btn--primary appui-btn--sm" @click="openQuiz()">+ Inserir questão</button>
            </div>
            <table class="appui-table">
              <thead>
                <tr>
                  <th style="width:46px"></th>
                  <th style="width:56px">Seq</th>
                  <th>Pergunta</th>
                  <th style="width:90px">Respostas</th>
                  <th style="width:90px">Liberada</th>
                  <th style="width:70px;text-align:right">Ações</th>
                </tr>
              </thead>
              <draggable
                v-model="quiz"
                :element="'tbody'"
                :options="{ animation: 180, handle: '.appui-grip', ghostClass: 'appui-drag-ghost' }"
                @end="reorderQuiz"
              >
                <tr v-for="q in quiz" :key="q.id" :class="{ 'appui-row-archived': q.archived }">
                  <td><span class="appui-grip" title="Arraste para reordenar">⠿</span></td>
                  <td><span class="appui-badge appui-badge--blue">{{ q.sequence }}</span></td>
                  <td :title="q.asking" style="color:#495057">{{ truncate(q.asking, 80) }}<span v-if="q.archived" class="appui-badge appui-badge--muted" style="margin-left:8px">Arquivado</span></td>
                  <td style="color:#74788d">{{ (q.answers || []).length }}</td>
                  <td>
                    <button class="appui-switch" :class="{ 'is-on': q.status }" :disabled="!!q.archived" @click="toggleLive(q, 'quiz')"><span class="knob"></span></button>
                  </td>
                  <td style="text-align:right">
                    <b-dropdown right variant="white" toggle-class="p-0 appui-dots">
                      <template v-slot:button-content><i class="mdi mdi-dots-horizontal font-size-18"></i></template>
                      <b-dropdown-item @click="openQuiz(q)"><i class="fas fa-pencil-alt text-success mr-1"></i> Editar</b-dropdown-item>
                      <b-dropdown-item @click="archiveItem(q, 'quiz')"><i class="fas fa-archive text-warning mr-1"></i> {{ q.archived ? 'Desarquivar' : 'Arquivar' }}</b-dropdown-item>
                      <b-dropdown-item @click="delQuiz(q)"><i class="fas fa-trash-alt text-danger mr-1"></i> Excluir</b-dropdown-item>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item @click="openChart(q, 'quiz')"><i class="fas fa-chart-bar text-primary mr-1"></i> Gráfico</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                <tr v-if="!quiz.length"><td colspan="6" class="appui-empty">Nenhum quiz configurado.</td></tr>
              </draggable>
            </table>
          </section>

          <!-- NUVEM DE PALAVRAS -->
          <section v-if="activeTab === 'nuvem'" class="appui-card appui-card--flush">
            <div class="appui-tab-head">
              <span class="appui-sec-title">Nuvem de palavras</span>
              <button class="appui-btn appui-btn--primary appui-btn--sm" @click="openCloud()">+ Inserir nuvem</button>
            </div>
            <table class="appui-table">
              <thead>
                <tr>
                  <th>Pergunta</th>
                  <th style="width:110px">Palavras</th>
                  <th style="width:90px">Liberada</th>
                  <th style="width:70px;text-align:right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in wordClouds" :key="c.id" :class="{ 'appui-row-archived': c.archived }">
                  <td :title="c.description" style="color:#495057">{{ truncate(c.description, 80) }}<span v-if="c.archived" class="appui-badge appui-badge--muted" style="margin-left:8px">Arquivada</span></td>
                  <td>
                    <a class="appui-link" style="color:#556ee6;font-weight:600" @click="openWords(c)">{{ (c.words_group || []).length }} <i class="bx bx-window-open"></i></a>
                  </td>
                  <td>
                    <button class="appui-switch" :class="{ 'is-on': c.status }" :disabled="!!c.archived" @click="toggleLive(c, 'cloud')"><span class="knob"></span></button>
                  </td>
                  <td style="text-align:right">
                    <b-dropdown right variant="white" toggle-class="p-0 appui-dots">
                      <template v-slot:button-content><i class="mdi mdi-dots-horizontal font-size-18"></i></template>
                      <b-dropdown-item @click="openCloud(c)"><i class="fas fa-pencil-alt text-success mr-1"></i> Editar</b-dropdown-item>
                      <b-dropdown-item @click="archiveItem(c, 'cloud')"><i class="fas fa-archive text-warning mr-1"></i> {{ c.archived ? 'Desarquivar' : 'Arquivar' }}</b-dropdown-item>
                      <b-dropdown-item @click="delCloud(c)"><i class="fas fa-trash-alt text-danger mr-1"></i> Excluir</b-dropdown-item>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item @click="openCloudView(c)"><i class="fas fa-eye text-primary mr-1"></i> Visualizar</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                <tr v-if="!wordClouds.length"><td colspan="4" class="appui-empty">Nenhuma nuvem de palavras configurada.</td></tr>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </div>

    <!-- MODAL: responder pergunta (privada/pública) -->
    <b-modal v-model="replyModal" title="Pergunta" hide-footer>
      <table class="table table-sm mb-3" style="font-size:13px">
        <tbody>
          <tr><th style="width:90px">Nome</th><td>{{ replyForm.authorName || '—' }}</td></tr>
          <tr><th>E-mail</th><td>{{ replyForm.authorEmail || '—' }}</td></tr>
          <tr v-if="replyForm.isPublic"><th>Votos</th><td>{{ replyForm.votes }}</td></tr>
          <tr><th>Pergunta</th><td>{{ replyForm.asking }}</td></tr>
          <tr><th>Data</th><td>{{ replyForm.createdAt }}</td></tr>
        </tbody>
      </table>
      <form @submit.prevent="submitReply()">
        <div class="form-group">
          <label>Resposta *</label>
          <textarea class="form-control" rows="3" v-model="replyForm.text" :disabled="replyForm.status > 0" required></textarea>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-light mr-2" @click="replyModal = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="replySaving || replyForm.status > 0">Responder</button>
        </div>
      </form>
    </b-modal>

    <!-- MODAL: enquete (criar/editar) -->
    <b-modal v-model="pollModal" :title="pollForm.id ? 'Editar enquete' : 'Cadastre uma enquete'" size="lg" hide-footer>
      <form @submit.prevent="savePoll()">
        <div class="row">
          <div class="form-group col-sm-8"><label>Descrição *</label><input type="text" class="form-control" v-model="pollForm.description" required></div>
          <div class="form-group col-sm-4">
            <label>Exibir resultado *</label>
            <select class="custom-select" v-model.number="pollForm.show_result">
              <option :value="0">Não</option>
              <option :value="1">Sim</option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="mb-0">Opções</label>
          <a href="#" style="font-size:12.5px" @click.prevent="addPollOption()">+ Adicionar</a>
        </div>
        <input type="file" accept="image/*" ref="pollImage" style="display:none" @change="onPollImage">
        <div v-for="(o, i) in pollForm.options" :key="i" class="d-flex align-items-center mb-2" style="gap:10px">
          <div class="appui-opt-thumb" :title="o.preview || o.picture ? 'Trocar imagem' : 'Adicionar imagem'" @click="pickPollImage(i)">
            <img v-if="o.preview || o.picture" :src="o.preview || o.picture">
            <i v-else class="mdi mdi-image-plus"></i>
          </div>
          <input type="text" class="form-control" v-model="o.option" placeholder="Opção" required>
          <button type="button" class="appui-icon-btn appui-icon-btn--danger" title="Remover opção" @click="removePollOption(i)"><i class="mdi mdi-trash-can-outline"></i></button>
        </div>
        <div class="text-right" style="margin-top:16px">
          <button type="button" class="btn btn-light mr-2" @click="pollModal = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="pollSaving">Salvar</button>
        </div>
      </form>
    </b-modal>

    <!-- MODAL: quiz (criar/editar) -->
    <b-modal v-model="quizModal" :title="quizForm.id ? 'Editar questão' : 'Cadastre uma questão'" size="lg" hide-footer>
      <form @submit.prevent="saveQuiz()">
        <div class="row">
          <div class="form-group col-sm-8"><label>Questão *</label><input type="text" class="form-control" v-model="quizForm.asking" required></div>
          <div class="form-group col-sm-4">
            <label>Exibir resposta *</label>
            <select class="custom-select" v-model.number="quizForm.show_answer">
              <option :value="0">Não</option>
              <option :value="1">Sim</option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="mb-0">Respostas</label>
          <a href="#" style="font-size:12.5px" @click.prevent="addQuizAnswer()">+ Adicionar</a>
        </div>
        <div v-for="(a, i) in quizForm.answers" :key="i" class="d-flex align-items-center mb-2" style="gap:10px">
          <input type="text" class="form-control" v-model="a.answer" placeholder="Resposta" required>
          <select class="custom-select" style="max-width:130px" v-model.number="a.correct" title="Correta?">
            <option :value="0">Incorreta</option>
            <option :value="1">Correta</option>
          </select>
          <button type="button" class="appui-icon-btn appui-icon-btn--danger" title="Remover resposta" @click="removeQuizAnswer(i)"><i class="mdi mdi-trash-can-outline"></i></button>
        </div>
        <div class="text-right" style="margin-top:16px">
          <button type="button" class="btn btn-light mr-2" @click="quizModal = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="quizSaving">Salvar</button>
        </div>
      </form>
    </b-modal>

    <!-- MODAL: nuvem de palavras (criar/editar) -->
    <b-modal v-model="cloudModal" :title="cloudForm.id ? 'Editar nuvem de palavras' : 'Cadastrar nuvem de palavras'" size="lg" hide-footer>
      <form @submit.prevent="saveCloud()">
        <div class="form-group"><label>Pergunta *</label><input type="text" class="form-control" v-model="cloudForm.description" placeholder="Exemplo: Qual o seu sentimento hoje?" required></div>
        <div class="row">
          <div class="form-group col-sm-6">
            <label>Palavras por usuário *</label>
            <select class="custom-select" v-model.number="cloudForm.word_limit">
              <option :value="0">Sem limites</option>
              <option v-for="n in wordLimits" :key="n" :value="n">{{ n }} {{ n === 1 ? 'palavra' : 'palavras' }}</option>
            </select>
          </div>
          <div class="form-group col-sm-6">
            <label>Filtro de palavrões</label>
            <select class="custom-select" v-model.number="cloudForm.block_bad_words" disabled>
              <option :value="1">Sim</option>
              <option :value="0">Não</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label>Bloquear palavras</label>
          <textarea class="form-control" rows="5" v-model="cloudForm.bad_words" placeholder="Separe por vírgula"></textarea>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-light mr-2" @click="cloudModal = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="cloudSaving">Salvar</button>
        </div>
      </form>
    </b-modal>

    <!-- MODAL: palavras da nuvem (ver/excluir) -->
    <b-modal v-model="wordsModal" :title="wordsCloud.description || 'Palavras'" hide-footer>
      <table class="appui-table">
        <thead><tr><th>Palavra</th><th style="width:70px">Qtd</th><th style="width:60px;text-align:right"></th></tr></thead>
        <tbody>
          <tr v-for="w in (wordsCloud.words_group || [])" :key="w.word">
            <td>{{ w.word }}</td>
            <td style="color:#74788d">{{ w.total }}</td>
            <td style="text-align:right">
              <button class="appui-icon-btn appui-icon-btn--danger" title="Remover palavra" @click="delWord(wordsCloud, w.word)"><i class="mdi mdi-trash-can-outline"></i></button>
            </td>
          </tr>
          <tr v-if="!(wordsCloud.words_group || []).length"><td colspan="3" class="appui-empty">Nenhuma palavra enviada.</td></tr>
        </tbody>
      </table>
      <div class="text-right" style="margin-top:12px"><button class="btn btn-light" @click="wordsModal = false">Fechar</button></div>
    </b-modal>

    <!-- MODAL: visualizar nuvem -->
    <b-modal v-model="cloudViewModal" :title="'Resultado — ' + (wordsCloud.description || 'Nuvem de palavras')" size="lg" hide-footer>
      <div style="min-height:180px;display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:10px 16px;padding:14px">
        <span
          v-for="w in (wordsCloud.words_group || [])"
          :key="w.word"
          :style="{ fontSize: wordFont(w.total), color: wordColor(w.word), fontWeight: 600 }"
        >{{ w.word }}</span>
        <span v-if="!(wordsCloud.words_group || []).length" style="color:#adb5bd">Nenhuma palavra enviada ainda.</span>
      </div>
      <div class="text-right"><button class="btn btn-light" @click="cloudViewModal = false">Fechar</button></div>
    </b-modal>

    <!-- MODAL: resultado (enquete/quiz) -->
    <b-modal v-model="chartModal" :title="'Resultado — ' + chartData.title" size="lg" hide-footer>
      <div style="padding:4px 2px 10px">
        <div v-for="r in chartData.items" :key="r.id" style="margin-bottom:12px">
          <div style="display:flex;justify-content:space-between;font-size:12.5px;margin-bottom:3px">
            <span :style="r.correct ? 'color:#1a936f;font-weight:600' : 'color:#495057'">{{ r.label }} <i v-if="r.correct" class="mdi mdi-check"></i></span>
            <span style="color:#74788d">{{ r.total }} ({{ r.porcentagem }}%)</span>
          </div>
          <div class="appui-bar" style="height:10px"><div class="appui-bar-fill" :class="{ 'is-ok': r.correct }" :style="{ width: r.porcentagem + '%' }"></div></div>
        </div>
        <p v-if="!chartData.items.length" class="appui-empty">Sem votos até agora.</p>
        <div style="display:flex;justify-content:space-between;align-items:center;border-top:1px solid #eff2f7;padding-top:12px">
          <span style="font-size:12px;color:#74788d">Total de respostas: <strong>{{ chartData.total }}</strong></span>
          <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="refreshChart()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: { draggable },
  name: 'app-room-edit',
  data () {
    return {
      id: this.$route.params.id,
      room: {},
      activeTab: 'perguntas',
      settings: {},
      askings: [],
      publicAskings: [],
      polls: [],
      quiz: [],
      wordClouds: [],
      statusLabels: ['Não respondida', 'Respondida', 'Respondida ao vivo'],
      wordLimits: [1, 2, 3, 4, 5, 10],
      tabs: [
        { key: 'perguntas', label: 'Perguntas privadas' },
        { key: 'publicas', label: 'Perguntas públicas' },
        { key: 'enquete', label: 'Enquetes' },
        { key: 'quiz', label: 'Quiz' },
        { key: 'nuvem', label: 'Nuvem de palavras' }
      ],
      toggles: [
        { key: 'asking', label: 'Perguntas privadas' },
        { key: 'asking_public', label: 'Perguntas públicas' },
        { key: 'poll', label: 'Enquetes' },
        { key: 'quiz', label: 'Quiz' },
        { key: 'word_cloud', label: 'Nuvem de palavras' }
      ],
      replyModal: false,
      replySaving: false,
      replyForm: {},
      pollModal: false,
      pollSaving: false,
      pollForm: { id: null, description: '', show_result: 0, options: [] },
      pollImgIndex: null,
      quizModal: false,
      quizSaving: false,
      quizForm: { id: null, asking: '', show_answer: 0, answers: [] },
      cloudModal: false,
      cloudSaving: false,
      cloudForm: { id: null, description: '', word_limit: 0, block_bad_words: 1, bad_words: '' },
      wordsModal: false,
      cloudViewModal: false,
      wordsCloud: {},
      chartModal: false,
      chartData: { title: '', type: null, id: null, items: [], total: 0 }
    }
  },
  mounted () {
    services.showRoom(this.id).then(r => { this.room = r.data.data })
    services.getRoomSettings(this.id).then(r => { this.settings = r.data.data })
    this.loadAll()
  },
  methods: {
    /* ===== helpers ===== */
    truncate (str, n) { return (str || '').length > n ? str.slice(0, n) + '...' : (str || '') },
    fmtDate (d) {
      if (!d) return '—'
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    votesOf (a) { return a.votes_count != null ? a.votes_count : (a.total_votes || 0) },
    confirm () { return this.$bvModal.msgBoxConfirm('Essa ação não poderá ser revertida.', { title: 'Você tem certeza?', okTitle: 'Sim, remover', cancelTitle: 'Cancelar', okVariant: 'danger' }) },

    /* ===== carregamento ===== */
    loadAll () {
      this.loadAskings()
      this.loadPublicAskings()
      this.loadPolls()
      this.loadQuiz()
      this.loadClouds()
    },
    loadAskings () { services.listRoomAskings(this.id).then(r => { this.askings = r.data.data }) },
    loadPublicAskings () { services.listRoomPublicAskings(this.id).then(r => { this.publicAskings = r.data.data }) },
    loadPolls () { services.listRoomPolls(this.id).then(r => { this.polls = r.data.data }) },
    loadQuiz () { services.listRoomQuiz(this.id).then(r => { this.quiz = r.data.data }) },
    loadClouds () { services.listRoomWordClouds(this.id).then(r => { this.wordClouds = r.data.data }) },

    /* ===== controles de interatividade (salva ao alternar) ===== */
    async toggleSetting (key) {
      const val = this.settings[key] ? 0 : 1
      this.$set(this.settings, key, val)
      try {
        await services.updateRoomSettings(this.id, { [key]: val })
      } catch (e) {
        this.$set(this.settings, key, val ? 0 : 1)
        errorMessage('Falha ao atualizar o recurso.', 3000)
      }
    },

    /* ===== perguntas (privadas/públicas) ===== */
    openReply (a, isPublic) {
      this.replyForm = {
        id: a.id,
        isPublic,
        status: a.status,
        asking: a.asking,
        authorName: a.author ? a.author.name : '',
        authorEmail: a.author ? a.author.email : '',
        votes: this.votesOf(a),
        createdAt: this.fmtDate(a.created_at),
        text: a.answer || ''
      }
      this.replyModal = true
    },
    async submitReply () {
      if (this.replyForm.status > 0) return
      this.replySaving = true
      try {
        if (this.replyForm.isPublic) await services.replyRoomPublicAsking(this.id, this.replyForm.id, { answer: this.replyForm.text })
        else await services.replyRoomAsking(this.id, this.replyForm.id, { answer: this.replyForm.text })
        this.replyModal = false
        successMessage('Resposta enviada.', 2000)
        this.replyForm.isPublic ? this.loadPublicAskings() : this.loadAskings()
      } catch (e) { errorMessage('Falha ao responder.', 3000) } finally { this.replySaving = false }
    },
    async setAskingStatus (a, isPublic, status) {
      try {
        if (isPublic) await services.statusRoomPublicAsking(this.id, a.id, status)
        else await services.statusRoomAsking(this.id, a.id, status)
        a.status = status
        successMessage('Status atualizado.', 2000)
      } catch (e) { errorMessage('Falha ao atualizar status.', 3000) }
    },
    async delAsking (a, isPublic) {
      if (!(await this.confirm())) return
      try {
        if (isPublic) { await services.deleteRoomPublicAsking(this.id, a.id); this.loadPublicAskings() } else { await services.deleteRoomAsking(this.id, a.id); this.loadAskings() }
      } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },

    /* ===== liberar/arquivar (enquete, quiz, nuvem) ===== */
    async toggleLive (item, type) {
      const prev = item.status
      item.status = item.status ? 0 : 1
      try {
        if (type === 'poll') await services.statusRoomPoll(this.id, item.id)
        else if (type === 'quiz') await services.statusRoomQuiz(this.id, item.id)
        else await services.statusRoomWordCloud(this.id, item.id)
      } catch (e) {
        item.status = prev
        errorMessage('Falha ao atualizar status.', 3000)
      }
    },
    async archiveItem (item, type) {
      try {
        if (type === 'poll') { await services.statusRoomPoll(this.id, item.id, { archived: 1 }); this.loadPolls() } else if (type === 'quiz') { await services.statusRoomQuiz(this.id, item.id, { archived: 1 }); this.loadQuiz() } else { await services.statusRoomWordCloud(this.id, item.id, { archived: 1 }); this.loadClouds() }
        successMessage(item.archived ? 'Item desarquivado.' : 'Item arquivado.', 2000)
      } catch (e) { errorMessage('Falha ao arquivar.', 3000) }
    },

    /* ===== enquetes ===== */
    openPoll (p) {
      this.pollForm = p
        ? {
          id: p.id,
          description: p.description,
          show_result: p.show_result ? 1 : 0,
          options: (p.options || []).map(o => ({ id: o.id, option: o.option, picture: o.picture, file: null, preview: null }))
        }
        : { id: null, description: '', show_result: 0, options: [this.emptyPollOption(), this.emptyPollOption()] }
      this.pollModal = true
    },
    emptyPollOption () { return { id: null, option: '', picture: null, file: null, preview: null } },
    addPollOption () { this.pollForm.options.push(this.emptyPollOption()) },
    async removePollOption (i) {
      if (this.pollForm.options.length <= 1) { errorMessage('A enquete precisa de pelo menos uma opção.', 2500); return }
      const opt = this.pollForm.options[i]
      if (opt.id) {
        if (!(await this.confirm())) return
        try { await services.deleteRoomPollOption(this.id, this.pollForm.id, opt.id) } catch (e) { errorMessage('Falha ao remover opção.', 3000); return }
      }
      this.pollForm.options.splice(i, 1)
    },
    pickPollImage (i) { this.pollImgIndex = i; this.$refs.pollImage.click() },
    onPollImage (e) {
      const f = e.target.files[0]
      e.target.value = ''
      if (!f || this.pollImgIndex == null) return
      if (!f.type.startsWith('image/')) { errorMessage('Envie um arquivo de imagem.', 2500); return }
      if (f.size > 1024 * 1024) { errorMessage('A imagem deve ter no máximo 1 MB.', 2500); return }
      const opt = this.pollForm.options[this.pollImgIndex]
      opt.file = f
      opt.preview = URL.createObjectURL(f)
      this.pollImgIndex = null
    },
    async savePoll () {
      const opts = this.pollForm.options.filter(o => (o.option || '').trim())
      if (!this.pollForm.id && opts.length < 2) { errorMessage('Cadastre pelo menos 2 opções.', 2500); return }
      this.pollSaving = true
      try {
        const fd = new FormData()
        fd.append('description', this.pollForm.description)
        fd.append('show_result', this.pollForm.show_result)
        opts.forEach((o, i) => {
          if (o.id) fd.append(`options[${i}][id]`, o.id)
          fd.append(`options[${i}][option]`, o.option)
          if (o.file) fd.append(`options[${i}][picture]`, o.file)
        })
        if (this.pollForm.id) {
          fd.append('_method', 'PUT')
          await services.updateRoomPoll(this.id, this.pollForm.id, fd)
        } else {
          await services.createRoomPoll(this.id, fd)
        }
        this.pollModal = false
        successMessage('Enquete salva.', 2000)
        this.loadPolls()
      } catch (e) { errorMessage('Falha ao salvar enquete.', 3000) } finally { this.pollSaving = false }
    },
    async delPoll (p) {
      if (!(await this.confirm())) return
      try { await services.deleteRoomPoll(this.id, p.id); this.loadPolls() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async reorderPolls () {
      try { await services.reorderRoomPolls(this.id, this.polls.map(it => ({ id: it.id }))); this.loadPolls() } catch (e) { errorMessage('Falha ao reordenar.', 3000); this.loadPolls() }
    },

    /* ===== quiz ===== */
    openQuiz (q) {
      this.quizForm = q
        ? {
          id: q.id,
          asking: q.asking,
          show_answer: q.show_answer ? 1 : 0,
          answers: (q.answers || []).map(a => ({ id: a.id, answer: a.answer, correct: a.correct ? 1 : 0 }))
        }
        : { id: null, asking: '', show_answer: 0, answers: [{ id: null, answer: '', correct: 0 }, { id: null, answer: '', correct: 0 }] }
      this.quizModal = true
    },
    addQuizAnswer () { this.quizForm.answers.push({ id: null, answer: '', correct: 0 }) },
    async removeQuizAnswer (i) {
      if (this.quizForm.answers.length <= 1) { errorMessage('O quiz precisa de pelo menos uma resposta.', 2500); return }
      const ans = this.quizForm.answers[i]
      if (ans.id) {
        if (!(await this.confirm())) return
        try { await services.deleteRoomQuizAnswer(this.id, this.quizForm.id, ans.id) } catch (e) { errorMessage('Falha ao remover resposta.', 3000); return }
      }
      this.quizForm.answers.splice(i, 1)
    },
    async saveQuiz () {
      const answers = this.quizForm.answers.filter(a => (a.answer || '').trim())
      if (!this.quizForm.id && answers.length < 2) { errorMessage('Cadastre pelo menos 2 respostas.', 2500); return }
      this.quizSaving = true
      try {
        const payload = {
          asking: this.quizForm.asking,
          show_answer: this.quizForm.show_answer,
          answers: answers.map(a => ({ id: a.id || undefined, answer: a.answer, correct: a.correct }))
        }
        if (this.quizForm.id) await services.updateRoomQuiz(this.id, this.quizForm.id, payload)
        else await services.createRoomQuiz(this.id, payload)
        this.quizModal = false
        successMessage('Quiz salvo.', 2000)
        this.loadQuiz()
      } catch (e) { errorMessage('Falha ao salvar quiz.', 3000) } finally { this.quizSaving = false }
    },
    async delQuiz (q) {
      if (!(await this.confirm())) return
      try { await services.deleteRoomQuiz(this.id, q.id); this.loadQuiz() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async reorderQuiz () {
      try { await services.reorderRoomQuiz(this.id, this.quiz.map(it => ({ id: it.id }))); this.loadQuiz() } catch (e) { errorMessage('Falha ao reordenar.', 3000); this.loadQuiz() }
    },

    /* ===== gráfico (enquete/quiz) ===== */
    openChart (item, type) {
      this.chartData = { title: type === 'poll' ? item.description : item.asking, type, id: item.id, items: [], total: 0 }
      this.applyChartResults(item.results || [], type)
      this.chartModal = true
      this.refreshChart()
    },
    applyChartResults (results, type) {
      this.chartData.items = (results || []).map(r => ({
        id: r.id,
        label: type === 'poll' ? r.option : r.answer,
        correct: type === 'quiz' ? !!r.correct : false,
        total: r.total,
        porcentagem: r.porcentagem
      }))
      this.chartData.total = this.chartData.items.reduce((s, r) => s + (r.total || 0), 0)
    },
    async refreshChart () {
      const { type, id } = this.chartData
      if (!id) return
      try {
        const res = type === 'poll' ? await services.chartRoomPoll(this.id, id) : await services.chartRoomQuiz(this.id, id)
        this.applyChartResults(res.data.result || [], type)
      } catch (e) { /* mantém snapshot atual */ }
    },

    /* ===== nuvem de palavras ===== */
    openCloud (c) {
      this.cloudForm = c
        ? { id: c.id, description: c.description, word_limit: c.word_limit || 0, block_bad_words: c.block_bad_words != null ? c.block_bad_words : 1, bad_words: c.bad_words || '' }
        : { id: null, description: '', word_limit: 0, block_bad_words: 1, bad_words: '' }
      this.cloudModal = true
    },
    async saveCloud () {
      this.cloudSaving = true
      try {
        const payload = {
          description: this.cloudForm.description,
          word_limit: this.cloudForm.word_limit,
          block_bad_words: this.cloudForm.block_bad_words,
          bad_words: this.cloudForm.bad_words || null
        }
        if (this.cloudForm.id) await services.updateRoomWordCloud(this.id, this.cloudForm.id, payload)
        else await services.createRoomWordCloud(this.id, payload)
        this.cloudModal = false
        successMessage('Nuvem salva.', 2000)
        this.loadClouds()
      } catch (e) { errorMessage('Falha ao salvar nuvem.', 3000) } finally { this.cloudSaving = false }
    },
    async delCloud (c) {
      if (!(await this.confirm())) return
      try { await services.deleteRoomWordCloud(this.id, c.id); this.loadClouds() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    openWords (c) { this.wordsCloud = c; this.wordsModal = true },
    openCloudView (c) { this.wordsCloud = c; this.cloudViewModal = true },
    async delWord (c, word) {
      if (!(await this.confirm())) return
      try {
        await services.deleteRoomWord(this.id, c.id, word)
        c.words_group = (c.words_group || []).filter(w => w.word !== word)
      } catch (e) { errorMessage('Falha ao remover palavra.', 3000) }
    },
    wordFont (total) { return Math.min(10 + (total || 1) * 4, 46) + 'px' },
    wordColor (word) {
      const palette = ['#556ee6', '#34c38f', '#f1b44c', '#50a5f1', '#f46a6a', '#6f42c1', '#0dcaf0']
      let h = 0
      for (let i = 0; i < word.length; i++) h = (h * 31 + word.charCodeAt(i)) % palette.length
      return palette[h]
    }
  }
}
</script>
